
import HeroAbout from '../../components/HeroComponents/HeroAbout'

import Team from "../../components/Team";
import Facts from "../../components/Facts";
import About from "../../components/About";
import Feature from "../../components/Feature";

export default function AboutPage() {
  return (
 <>
 <HeroAbout />
 <Feature />
 <About />
 <Facts />
 <Team />



 </>
  )
}
